import { MainContent } from './MainContent'

export const MaintenanceScreen = () => {
  return <MainContent />
}
